import script from "./ActivationFirstStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationFirstStep.vue?vue&type=script&setup=true&lang=js"

import "./ActivationFirstStep.vue?vue&type=style&index=0&id=4dc53e98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc53e98"]])

export default __exports__